/**
 * Sets the 'preferred_language' cookie to persist user choice.
 * Matches the cookie name used by the PHP CookieDetector.
 */
const setLanguageCookie = (code: string): void => {
  const oneYear = 60 * 60 * 24 * 365;
  document.cookie = `preferred_language=${code}; path=/; max-age=${oneYear}; samesite=lax`;
};

export const initLanguageSwitcher = (): void => {
  const switchers = document.querySelectorAll<HTMLElement>(
    "[data-lang-switcher]",
  );

  if (switchers.length > 0) {
    switchers.forEach((switcher) => {
      const trigger = switcher.querySelector<HTMLButtonElement>(
        ".lang-switcher__trigger",
      );
      const dropdown = switcher.querySelector<HTMLElement>(
        ".lang-switcher__dropdown",
      );

      if (!trigger || !dropdown) return;

      const toggleSwitcher = (state?: boolean) => {
        const isOpening = state ?? !switcher.classList.contains("is-open");
        switcher.classList.toggle("is-open", isOpening);
        trigger.setAttribute("aria-expanded", String(isOpening));
        dropdown.setAttribute("aria-hidden", String(!isOpening));
      };

      trigger.addEventListener("click", (e) => {
        e.stopPropagation();
        toggleSwitcher();
      });

      document.addEventListener("click", (e) => {
        if (!switcher.contains(e.target as Node)) {
          toggleSwitcher(false);
        }
      });
    });
  }

  // --- Selection Logic (Cookie + Reload) ---
  const langLinks =
    document.querySelectorAll<HTMLAnchorElement>("[data-lang-code]");

  langLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const targetLang = link.dataset.langCode;

      if (targetLang) {
        setLanguageCookie(targetLang);
        window.location.reload();
      }
    });
  });
};
